import { useEffect, useState } from 'react';
import { shape } from 'prop-types';
import styled from 'styled-components';
import ReactPlayer from 'react-player'
import { getVideoUrl } from '../../services/mapService';
import DefaultLoading from '../Loading';
import Notification from '../StoraEnsoComponents/Notification';
import Section from '../Section';

const Loading = styled(DefaultLoading)`
  margin: 60px auto;
  justify-content: center;
`;

const ErrorWrapper = styled.div`
  margin: 60px auto;
  max-width: 75%;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

function VideoDetail({ projectData: { id } }) {
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [videoData, setVideoData] = useState(null);

  useEffect(() => {
    getVideoUrl(id)
      .then(data => {
        setVideoData(`${process.env.REACT_APP_API_URL}projects/detail/video/${data.id}/stream/${data.hash}`)
        console.log("URL")})
      .catch(err => setError(err))
      .then(() => setLoading(false));
  }, [id])

  return (
    <Section title="Video Detail" defaultCollapsedState={false}>
      {
        isLoading && (
          <Loading message="Loading video data..." />
        )
      }
      {
        error && (
          <ErrorWrapper>
              <Notification kind="negative" onClose={() => setError(false)}>An error has occurred while loading video data!</Notification>
          </ErrorWrapper>
        )
      }
      {
        videoData && (
          <Wrapper>
            <ReactPlayer url={videoData}  width="100%" height="100%" controls />
          </Wrapper>
        )
      }
    </Section>
  );
}

VideoDetail.propTypes = {
  projectData: shape({}).isRequired,
}

export default VideoDetail;